

































































































    import AbpBase from "@/lib/abpbase"
    import {Component, Prop, Watch} from "vue-property-decorator"
    import {QueryCreateSysDic, QueryEditSysDic, QuerySysDic, QueryMaterialsCreate, QueryMaterialsEdit} from "@/api/material"
    import {QueryManufacturer, QueryUnit} from "@/api/basicDictionary"

    @Component({
        components: {}
    })
    export default class AddOrEditMaterialClass extends AbpBase {
        @Prop({type: Boolean, default: false}) value: boolean
        @Prop({type: Object, default: {}}) data: any
        form:any = {
            code: '',
            materialName: '',
            alias: '',
            type: '',
            category: '',
            model: '',
            unit: '',
            basicUnit: '',
            unitRate: '',
            purchasePrice: '',
            manufacturer: '',
            stockWarn: '',
            isActive: true,
        }
        types = []  // 所有类型
        classes = [] // 所有分类
	    selectClasses = []
        units = []
        manufacturers = []
		async created() {
            await this.getSelects()
            if (this.data.mode === 'add') {

            } else if (this.data.mode === 'edit') {
                this.form = Object.assign({}, this.data.data)
                // this.form.materialName = this.form.name
                this.form.isActive = (this.data.data.status === "启用")
                this.selectClasses = this.classes.filter((item: any) => {
                    return item.parentId === this.form.type
                })

                // this.form.parentId =
            }
        }
        @Watch('form.materialName')
        nameChange(val:any, oldVal:any){
            console.log(val, oldVal)
        }
        get dialogTitle() {
            return this.data.mode === 'add' ? '新增' : '编辑'
        }
        typeChange(type:number){
            this.selectClasses = this.classes.filter((item:any)=>{
                return item.parentId === type
            })
	        this.form.category = ''
        }
        save() {
            (this.$refs.form as any).validate(async (valid: boolean) => {
                if (valid) {
                    let res
	                console.log(this.form)
                    if (this.data.mode === 'add') {
                        res = await QueryMaterialsCreate(this.form)
                    } else {
                        res = await QueryMaterialsEdit(this.form)
                    }
	                if (res.code === 2000) {
                        this.$emit('input', false)
                        this.$emit('save-success')
	                }
                }
            })
        }

        cancel() {
            (this.$refs.form as any).resetFields();
            this.$emit('input', false);
        }

        private async getSelects() {
	        let res = await QuerySysDic({
		        "dataType": 1,
                "typeName": "",
                "status": true
	        })
	        this.types = res.data
	        let res1 = await QuerySysDic({
		        "dataType": 2,
                "typeName": "",
                "status": true
	        })
	        this.classes = res1.data
	        let query = {
                queryString: "",
                pageSize: 10000,
                page: 1
            }
			let res2 = await QueryUnit(query)
	        this.units = res2.data.items
	        let res3 = await QueryManufacturer(query)
	        this.manufacturers = res3.data.items

        }
        rules = {
            code: {required: true, message: '请输入编号', trigger: 'blur'},
            materialName: {required: true, message: '请输入', trigger: 'blur'},
            purchasePrice: {required: true, message: '请输入', trigger: 'blur'},
            stockWarn: {required: true, message: '请输入', trigger: 'blur'},
            unitRate: {required: true, message: '请输入', trigger: 'blur'},
            type: {required: true, message: '请选择', trigger: 'blur'},
            category: {required: true, message: '请选择', trigger: 'blur'},
            unit: {required: true, message: '请选择', trigger: 'blur'},
            basicUnit: {required: true, message: '请选择', trigger: 'blur'},
            manufacturer: {required: true, message: '请选择', trigger: 'blur'},
        }
    }
